<div class="verifier-container">
    <div class="row my-5 px-3">
        <div class="col-12">
            <div class="shadow-wrapper">
                <div>
                    <h2 class="py-3">Total Complaints</h2>
                </div>
                <div *ngIf="complaints.data.length > 0; else noData" style="overflow-x: auto;">
                    <input type="text" class="form-control fontAwesome mb-2"
                        style="padding: 8px;margin-bottom: 10px;  width: 100% !important;"
                        (keyup)="applyFilter($any($event.target).value)" placeholder="Search">
                    <table mat-table [dataSource]="complaints" class="mat-elevation-z8" style="width: 100%;">

                        <!-- ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef>Sr.No.</th>
                            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                        </ng-container>

                        <!-- Ticket Id Column -->
                        <ng-container matColumnDef="ticket_id">
                            <th mat-header-cell *matHeaderCellDef>Ticket Id</th>
                            <td mat-cell *matCellDef="let element">{{ element.ticket_id }}</td>
                        </ng-container>

                        <!-- Date & Time Column -->
                        <ng-container matColumnDef="dateTime">
                            <th mat-header-cell *matHeaderCellDef>Created Date</th>
                            <td mat-cell *matCellDef="let element">{{ element.create_date }}</td>
                        </ng-container>

                        <!-- Zone Column -->
                        <ng-container matColumnDef="zone">
                            <th mat-header-cell *matHeaderCellDef>Zone</th>
                            <td mat-cell *matCellDef="let element">{{ element.zone }}</td>
                        </ng-container>


                        <!-- Days Open Column -->
                        <ng-container matColumnDef="days_open">
                            <th mat-header-cell *matHeaderCellDef>Days Open</th>
                            <td mat-cell *matCellDef="let element">{{ element.number_of_open_days }}</td>
                        </ng-container>


                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">{{ element.status}}</td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>Action</th>
                           <td mat-cell *matCellDef="let element; let i = index">
                                <div class="d-flex justify-content-center align-items-center">
                                    <h6 style="color: rgb(0, 26, 255); text-decoration: underline; cursor: pointer;"
                                        class="mt-2 view" (click)="route1(element)"
                                        matTooltip="View detailed information">
                                        View More
                                    </h6>


                                    <mat-icon style="cursor: pointer; vertical-align: middle; margin-left: 10px; color: rgb(0, 26, 255);" class="more-options-icon"
                                        [matMenuTriggerFor]="menu" matTooltip="More options">
                                        more_vert
                                    </mat-icon>
                                </div>


                                <mat-menu #menu="matMenu">
                                    <!-- <h6 mat-menu-item *ngIf="['PENDING', 'RESOLVED'].includes(element.status)"
                                        (click)="route(element)">
                                        <span
                                            style="color: rgb(134, 134, 135); text-decoration: underline;cursor: pointer; font-size: 14px;">Update</span>
                                    </h6> -->

                                    <h6 mat-menu-item (click)="onDownloadPDF(element)">
                                        <span
                                            style="color: rgb(1, 159, 244); text-decoration: underline;cursor: pointer; font-size: 14px;">Print
                                            Form</span>
                                    </h6>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <!-- Table Headers and Rows -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons
                    aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
            <ng-template #noData>
                <div class="text-center my-4" style="font-size: 18px; color: gray;">
                    Records not found!!
                </div>
            </ng-template>
        </div>
    </div>
</div>